import { createSlice } from '@reduxjs/toolkit';
import { handelCatch, handelResponse } from './globalSlice';
import { api } from 'services';

const initialState = {};
const whatsappChatSlice = createSlice({
  name: 'whatsappchat',
  initialState,
  reducers: {},
});

//Whatsapp Chat-Api
export const fetchWpChatData = (payload) => async (dispatch) => {
  try {
    const res = await api.post(`/get-whatsapp-chat`, payload);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const sendWpChatMessages = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/send-whatsapp-message', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchInputWindowStatus = (payload) => async (dispatch) => {
  try {
    const res = await api.post(`/user-window-status`, payload);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export default whatsappChatSlice.reducer;
